module.exports = __webpack_public_path__ + "static/media/logo.fb78c05f.svg";